import styled from "styled-components";
import IconButton from "../IconButton";

interface InputWrapperProps {
  $type?: "number";
}

export const InputWrapper = styled("div")<InputWrapperProps>`
  position: relative;
  width: 100%;
  margin-right: 10px;
  margin-bottom: 20px;

  input {
    width: 100%;
    padding-right: ${(props) => (props.$type === "number" ? "14px" : "36px")};
  }

  ${(props) => props.theme.sm`
    margin: 0 0 10px 0;
  `}
`;

// Search or clear, inside the field's right edge.
export const SearchButton = styled(IconButton).attrs({ compact: true })`
  position: absolute;
  right: 7px;
  top: 50%;
  transform: translateY(-50%);
`;
